exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1KxSeveZprC2bdklX5SaDj{padding:10px 20px;background:#eee;display:flex;flex-wrap:wrap}._1KxSeveZprC2bdklX5SaDj .Rn3XJefuofKX_Xpl-LVch{margin-bottom:5px;font-size:20px;line-height:22px;font-weight:500;cursor:default;white-space:nowrap;min-width:0;flex:1 1 33%}._1KxSeveZprC2bdklX5SaDj .Rn3XJefuofKX_Xpl-LVch ._3wacNyV-AlTFYIlVT14vo3{opacity:0.5;margin-right:5px}._1KxSeveZprC2bdklX5SaDj .Rn3XJefuofKX_Xpl-LVch ._2NAFlp1QFCWb0fqyjKOk_M{display:inline-block;font-size:13px;font-weight:400;margin-left:5px}._1KxSeveZprC2bdklX5SaDj .Rn3XJefuofKX_Xpl-LVch ._1DUb2oC9zjPvR5zm4e2W5{color:#fa6400;font-size:20px;margin-left:5px}._1KxSeveZprC2bdklX5SaDj ._1sL6pS8axkDLKDYL-eKVx0{opacity:0.5}\n", ""]);

// Exports
exports.locals = {
	"TRouteAtAGlance": "_1KxSeveZprC2bdklX5SaDj",
	"Metric": "Rn3XJefuofKX_Xpl-LVch",
	"icon": "_3wacNyV-AlTFYIlVT14vo3",
	"units": "_2NAFlp1QFCWb0fqyjKOk_M",
	"premiumRequired": "_1DUb2oC9zjPvR5zm4e2W5",
	"pendingMetric": "_1sL6pS8axkDLKDYL-eKVx0"
};